import CesiumManagerWrapper from "./CesiumManagerWrapper";
import Abstract3DMapHandler from "./Abstract3DMapHandler";
import ConfirmationModal from "../../common/ConfirmationModal";
import PointsConverter from "./PointsConverter"

export default class TrackMap3DHandler extends Abstract3DMapHandler {

    constructor(first_appear_ad = 100, frequency_ad = 100) {
        super(first_appear_ad, frequency_ad);
        
        this.loaded_counter = 0;

        this.scene_type = "other";
        this.start_timer();
    }

    start_timer() {
        super.start_timer("replay_map");
    }

    async init(data) {        
        this.tracks = data.tracks;
        this.scene_type = data.scene_type;
        this.track_ids = data.track_ids;
        this.show_related_tracks = data.show_related_tracks;
        this.start_in_fpv_mode = data.start_in_fpv_mode;
        this.activity_type = data.activity_type;
        this.category_name = data.category_name;
        this.started_at_date = data.started_at_date;
        this.started_at_time = data.started_at_time;
        this.host = data.host;
        this.related_tracks = data.related_tracks || {};
        this.contest_tasks = data.contest_tasks || {};
        
        const params = new URLSearchParams(window.location.search);
        const contestParam = params.get("contestTaskId");
        if (contestParam) {
            this.use_contest_task_id = contestParam;
        } else {
            this.use_contest_task_id = null; 
        }

        if (!this.use_contest_task_id && this.contest_tasks.length > 0) {
            if (this.contest_tasks.length === 1) {
                this.use_contest_task_id = this.contest_tasks[0].id;
            } else if (this.contest_tasks.length > 1) {
                this.confirmationModal = new ConfirmationModal();
                const message = {};
                message["positive_btn"] = {
                    type: "danger",
                    label: I18n.t("website.user.contest_tasks.no_task"),
                    callback: () => {
                        this.use_contest_task_id = null;
                        $("#confirm_modal").one("hide.bs.modal", () => {
                            requestAnimationFrame(() => {
                                this.handleRelatedTracks();
                            });
                        });
                        $("#confirm_modal").modal("hide");
                    }
                };
    
                let html = `
                    <div class="container">
                        <div class="row font-weight-bold py-2">
                            <div class="col fs-11">ID</div>
                            <div class="col fs-11">Name</div>
                            <div class="col fs-11">Start</div>
                            <div class="col fs-11">Updated</div>
                        </div>
                `;
                this.contest_tasks.forEach(task => {
                    html += `
                        <div class="row cursor-pointer contest-task-item py-1" data-task-id="${task.id}">
                            <div class="col fs-13">${task.id}</div>
                            <div class="col fs-13">${task.name}</div>
                            <div class="col fs-13">${task.start_time_begins || ''}</div>
                            <div class="col fs-13">${task.updated_at || ''}</div>
                        </div>
                    `;
                });
                html += `</div>`;
    
                this.confirmationModal.displayConfirm(
                    I18n.t("website.user.contest_tasks.title"),
                    html,
                    message
                );

                $(document).on("click", ".contest-task-item", (e) => {
                    let selectedId = $(e.currentTarget).data("task-id");
                    this.use_contest_task_id = selectedId;
                    let url = new URL(window.location.href);
                    url.searchParams.set("contestTaskId", selectedId);
                    window.history.replaceState({}, '', url.toString());
                    
                    $("#confirm_modal").modal("hide");
                    $(document).off("click", ".contest-task-item");
                    this.loadTracks();
                });

                return;
            }
        }

        // Check if any related track exists
        if (!this.use_contest_task_id && ((this.related_tracks?.for_track || 0) > 1 || (this.related_tracks?.for_activity_type || 0) > 0)) {
            this.handleRelatedTracks();
        } else {
            // No confirmation needed, load directly tracks
            await this.loadTracks();
        }
    }

    async handleRelatedTracks() {
        this.confirmationModal = new ConfirmationModal();
        const message = {};
        let confirmationNeeded = false;
    
        if (this.related_tracks["for_track"] > 1) {
            confirmationNeeded = true;
            message["negative_btn"] = {
                label: I18n.t("website.user.related_tracks.merge_tracks"),
                callback: () => {
                    window.location.href = window.application.getMeta("3d-url") + "&related=true";
                }
            };
            message["positive_btn"] = {
                type: "danger",
                label: I18n.t("website.user.related_tracks.only_one_track"),
                callback: () => {
                    this.loadTracks();
                }
            };
    
            this.confirmationModal.displayConfirm(
                I18n.t("website.user.related_tracks.title"),
                I18n.t("website.user.related_tracks.message", { 
                    related_tracks_count: this.related_tracks["for_track"],
                    started_at_date: this.started_at_date,
                    started_at_time: this.started_at_time
                }),
                message
            );
        }
    
        if (this.related_tracks["for_activity_type"] > 0) {
            confirmationNeeded = true;
            message["negative_btn"] = {
                type: "danger",
                label: I18n.t("website.user.related_tracks.merge_tracks_per_activity", {
                    activity_type: this.activity_type,
                }),
                callback: () => {
                    window.location.href = window.application.getMeta("3d-url") + "&related=activity_type";
                }
            };
            message["positive_btn"] = {
                type: "danger",
                label: I18n.t("website.user.related_tracks.resume_viewing", { 
                    category_name: this.category_name
                }),
                callback: () => {
                    this.loadTracks();
                }
            };
    
            this.confirmationModal.displayConfirm(
                I18n.t("website.user.related_tracks.title"),
                I18n.t("website.user.related_tracks.message_multiple_activity_type", { 
                    activity_type: this.activity_type,
                    related_tracks_count: this.related_tracks["for_activity_type"]
                }),
                message
            );
        }
    
        if (!confirmationNeeded) {
            await this.loadTracks();
        }
    }

    async loadTracks(related = false) {     
        $("#loading_scene_modal").modal({
            backdrop: 'static',
            keyboard: false
        });

        const loading = this.tracks.map((x,i) => this.getTrack(x,i));
        await Promise.all(loading);
        
        await this.getAlongRoute(this.tracks[0].id);
        await this.startCesium();
    }

    async startCesium() {
        var userData = [];
        for (var i = 0; i < this.tracks.length; i++) {
            var data = {
                userId: this.tracks[i].user.id,
                userName: this.tracks[i].user.user_name,
                profileUrl: this.tracks[i].user.user_url,
                avatarUrl: this.tracks[i].user.profile_picture_url,
                track: {
                    id: this.tracks[i].id,
                    color: this.tracks[i].user.color,
                    maxAltitude: this.tracks[i].max_altitude,
                    started_at: this.tracks[i].started_at,
                    finished_at: this.tracks[i].finished_at,
                    created_at: this.tracks[i].created_at,
                    // Set activity_icon per track 
                    activity_icon: this.tracks[i].activity_icon,
                    time_zone: this.tracks[i].time_zone,
                    raw_points_data: this.points[i]
                },
            }
            if (i == 0) {
                data["isDefault"] = true;
            }
            userData.push(data);
        }

        await CesiumManagerWrapper.initScene("map3D", {
            users: userData,
            checkContestType: "track",
            sceneType: this.scene_type,
            pathsLength: this.path_length,
            isFpvModeByDefault: this.start_in_fpv_mode,
            hostInUse: this.host,
            staticLabels: this.localities_around,
            contestIdInUse: this.use_contest_task_id  
        });

        setTimeout(function () {
            $("#loading_track_modal").modal("hide");
        }, 500)
    }

    getTrack(track,index) {
        var self = this;
        return new Promise((resolve, reject) => {
            var ajaxData = {
                url: window.application.getAPIUrl() + "/v1/users/" + track.user.id + "/track/" + track.id + "?type=" + this.show_related_tracks,
                method: "GET",
                beforeSend: this.beforeSendHandler,
            };

            $.ajax(ajaxData).done(function (data) {
                self.raw = data;
                var json = data;
                
                // Validate JSON response data
                if (!json || typeof json !== 'object') {
                    console.error("TrackMap3DHandler: Invalid JSON response", json);
                    reject(new Error("Invalid JSON response"));
                    return;
                }
                
                // Ensure points and points_header are valid arrays
                const validPoints = json.points && Array.isArray(json.points) ? json.points : [];
                const validPointsHeader = json.points_header && Array.isArray(json.points_header) ? json.points_header : [];
                
                // Log warning if data is missing
                if (!json.points || !Array.isArray(json.points)) {
                    console.warn("TrackMap3DHandler: Missing or invalid points data for track", track);
                }
                if (!json.points_header || !Array.isArray(json.points_header)) {
                    console.warn("TrackMap3DHandler: Missing or invalid points_header for track", track);
                }
                
                self.points[index] = { 
                    points: validPoints, 
                    points_header: validPointsHeader,
                    other_data: {
                        wind_data: json.wind_data || null
                    }
                };
                resolve();
            }).fail((err) => reject(err));
        });
    }

}